export default __webpack_public_path__ + "static/media/ATM.d88fe865.png";